/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, March 2020
 *
 *****************************************************************************/

/**
 * handle mobile number validation
 */
export const isPhoneValid = value => {
  // if mobile number is empty and only "+1" is remaining
  if (value === "+1") return false;

  // to avoid situation if all number selected and try to overwrite them
  if (!value.startsWith("+1")) return false;
  // validate number length mobile number (10) + "01 " (3) => total length 13
  if (value.length > 13) return false;

  // allow only digits
  let numberDigits = value.split(" ")[1];
  let reg = new RegExp("^\\d+$");
  if (!reg.test(numberDigits) && numberDigits !== "") return false;

  return true;
};

/**
 * handle verification code validation
 */
export const isCodeValid = value => {
  // validate verification code length
  if (value.length >= 7) return false;

  // allow only digits
  let reg = new RegExp("^\\d+$");
  if (!reg.test(value) && value !== "") return false;

  return true;
};
